import React from 'react';
import Text from 'components/Text/Text';
import { Checkbox, Form } from 'antd';
import style from './UseKmTariffCheckBox.module.scss';

interface IUseKmTariffCheckBox {
	toggleUseKmTariff: () => void;
	useKmTariff: boolean;
}

const UseKmTariffCheckBox: React.FC<IUseKmTariffCheckBox> = ({ toggleUseKmTariff, useKmTariff }) => {
	return (
		<Form.Item className={style.container} name="useKmTariff">
			<Checkbox checked={useKmTariff} onChange={toggleUseKmTariff}>
				<Text translationNameSpace="form" translationKey="kmTariffLabel" asFragment={true} />
			</Checkbox>
		</Form.Item>
	);
};

export default React.memo(UseKmTariffCheckBox);
